import { createFileRoute } from "@tanstack/react-router";
import { InvitePage } from "../components/invite/invite-page";
import { confirmSession } from "../lib/session-gate";

/**
 * Outside `_authenticated` on purpose: the person the email reaches may have no account yet. The
 * id in the address is the invitation's only credential; the page swaps this address for
 * `/invite` as soon as somebody is signed in.
 */
export const Route = createFileRoute("/invite/$id")({
  // The session store may still say "signed out" from before a sign-up was confirmed; ask again
  // before drawing, which is the same check every signed-in screen makes.
  beforeLoad: async () => {
    await confirmSession();
  },
  component: InviteLink,
});

function InviteLink() {
  const { id } = Route.useParams();
  return <InvitePage linkId={id} />;
}
